import React from 'react';
import SymbolDefs from 'otter_icons/symbol-defs.svg';

type Props = {
  ottercon: string,
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
};

export default function Ottercon({ ottercon, size }: Props) {
  const sizeClass = size ? ` bo-icon-${size}` : '';

  return (
    <svg className={`bo-icon bo-icon-${ottercon}${sizeClass}`}>
      <use href={`${SymbolDefs}#bo-icon-${ottercon}`}></use>
    </svg>
  );
}
